import axios from "axios";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { logout } from "../redux/actions/authAction";


let isInterceptorSet = false;

const setupAxiosInterceptors = ({ navigate, dispatch }) => {
  if (isInterceptorSet) return;
  isInterceptorSet = true;

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (!error.response) {
        console.error("Network Error: Please check your internet connection.");
        toast.error("Please check your internet connection.");
        setTimeout(() => {
          dispatch(logout());
        }, 5000);
        return Promise.reject(error);
      }

      // const { status } = error.response;

      // if (status === 401 || status === 403) {
      //   console.error("Unauthorized! Redirecting to login...");

      //   // dispatch(logout());

      //   setTimeout(() => {
      //     navigate("/login", { replace: true });
      //   }, 1000);
      // }

      return Promise.reject(error);
    }
  );
};

export default setupAxiosInterceptors;
